<script>
  import viewport from '@/js/utils/useViewportAction.js';
  import { page } from '@inertiajs/svelte';

  export let item;
  let grow = false;
</script>

<a href={item.link.url}>
  <div
    class="solutions-item"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <div class="solutions-item__image">
      <img
        src={item.image}
        alt={item.title}
        width={item.image.width}
        height={item.image.height}
        loading="lazy"
      />
    </div>
    <div class="solutions-item__content">
      <h5 class="solutions-item__title">{item.title}</h5>
      <a class="text-link text-small solutions-item__link" href={item.link.url}
        ><span>{$page.props.i18n.show_more}</span></a
      >
    </div>
  </div>
</a>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .solutions-item {
    border-radius: 20px;
    border: 1px solid $light-border;
    height: 43rem;
    position: relative;

    @include resp-max('xs') {
      height: 41rem;
    }

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &:hover {
      .solutions-item__image img {
        transform: scale(1.1);
      }
      .solutions-item__link {
        span {
          background-position: 100% 98%;
          color: var(--aqua-1);
        }
      }
    }

    &__image {
      border-radius: 20px 20px 0 0;
      aspect-ratio: 32/18;
      overflow: hidden;
      position: relative;
      width: 100%;
      max-height: 55%;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url(img/noise.png) 300px 300px;
      }

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        transition: all 1s cubic-bezier(0.22, 1, 0.36, 1);
      }
    }

    &__content {
      padding: 2rem 4rem 5rem;

      @include resp-max('xs') {
        padding-bottom: 0;
      }
    }

    &__title {
      @include resp-max('xs') {
        font-size: 2.4rem;
      }
    }

    &__link {
      margin-top: 2rem;
      color: var(--grey);
      position: absolute;
      bottom: 5rem;
      left: 4rem;

      &:after {
        background-position: 0 0;
      }

      &:hover {
        color: var(--royal);
      }
    }
  }
</style>
